(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	if (typeof gmInit == 'undefined') {
		console.log('gmInit is not defined - have you entered a valid Google Maps API key inside the admin?');

		return;
	}

	if (typeof SLEEK_CONFIG == 'undefined' || typeof SLEEK_CONFIG.GOOGLE_MAPS_API_KEY == 'undefined') {
		return;
	}

	var createMap = function (mapEl, lat, lng, infoWinContent) {
		lat = parseFloat(lat);
		lng = parseFloat(lng);

		if (lat && lng) {
			var map = new google.maps.Map(mapEl, {
				center: {
					lat: lat,
					lng: lng
				},
				zoom: 13,
				scrollwheel: false,
				mapTypeControl: false,
				streetViewControl: false,

				// https://snazzymaps.com/style/134/light-dream
				styles: [{"featureType": "administrative","elementType": "all","stylers": [{"visibility": "simplified"},{"gamma": "1.00"}]},{"featureType": "administrative.locality","elementType": "labels","stylers": [{"color": "#ba5858"}]},{"featureType": "administrative.neighborhood","elementType": "labels","stylers": [{"color": "#e57878"}]},{"featureType": "landscape","elementType": "geometry","stylers": [{"visibility": "simplified"},{"lightness": "65"},{"saturation": "-100"},{"hue": "#ff0000"}]},{"featureType": "poi","elementType": "geometry","stylers": [{"visibility": "simplified"},{"saturation": "-100"},{"lightness": "80"}]},{"featureType": "poi","elementType": "labels","stylers": [{"visibility": "off"}]},{"featureType": "poi.attraction","elementType": "labels","stylers": [{"visibility": "off"}]},{"featureType": "road.highway","elementType": "geometry","stylers": [{"visibility": "simplified"},{"color": "#dddddd"}]},{"featureType": "road.highway","elementType": "labels","stylers": [{"visibility": "off"}]},{"featureType": "road.highway.controlled_access","elementType": "labels","stylers": [{"visibility": "off"}]},{"featureType": "road.arterial","elementType": "geometry","stylers": [{"visibility": "simplified"},{"color": "#dddddd"}]},{"featureType": "road.arterial","elementType": "labels","stylers": [{"visibility": "off"}]},{"featureType": "road.local","elementType": "geometry","stylers": [{"visibility": "simplified"},{"color": "#eeeeee"}]},{"featureType": "road.local","elementType": "labels.text.fill","stylers": [{"color": "#ba5858"},{"saturation": "-100"}]},{"featureType": "transit.station","elementType": "all","stylers": [{"visibility": "off"}]},{"featureType": "transit.station","elementType": "labels.text.fill","stylers": [{"color": "#ba5858"},{"visibility": "simplified"}]},{"featureType": "transit.station","elementType": "labels.icon","stylers": [{"hue": "#ff0036"}]},{"featureType": "water","elementType": "geometry","stylers": [{"visibility": "simplified"},{"color": "#dddddd"}]},{"featureType": "water","elementType": "labels.text.fill","stylers": [{"color": "#ba5858"}]}]
			});

			var marker = new google.maps.Marker({
				position: new google.maps.LatLng(lat, lng),
				map: map,
				size: '10, 10',
				icon: '/wp-content/themes/bjork/dist/assets/pin.png'
			});

			var infoWin = false;

			if (infoWinContent) {
				infoWin = new google.maps.InfoWindow({
					content: '<div class="google-map-info-window">' + infoWinContent + '</div>'
				});

				marker.addListener('click', function () {
					infoWin.open(map, marker);
				});
			}

			return {
				map: map,
				marker: marker,
				infoWin: infoWin
			};
		}

		return false;
	};

	gmInit(function () {
		$('.google-map').each(function () {
			var mapEl = $(this);
			var lat = mapEl.attr('data-lat');
			var lng = mapEl.attr('data-lng');
			var address = mapEl.attr('data-address');
			var infoWin = mapEl.find('.google-map-info-window');
				infoWin = infoWin.length ? infoWin.html() : false;

			if (address) {
				address = JSON.parse(address);

				if (address) {
					address = address.address + ', ' + address.city + ', ' + address.postalcode;
				}
			}

			if (address) {
				var geocoder = new google.maps.Geocoder();

				geocoder.geocode({'address': address}, function (results, status) {
					if (status === 'OK') {
						createMap(mapEl[0], results[0].geometry.location.lat(), results[0].geometry.location.lng(), infoWin);
					}
				});
			}
			else {
				createMap(mapEl[0], lat, lng, infoWin);
			}
		});
	});
})();
